import type { BookingPeriodKind } from '../utils/assetBookingPricingOptions';
import type { MessageKey } from './messages';
import type { TranslateParams } from './translate';

export type BookingTranslateFn = (key: MessageKey, params?: TranslateParams) => string;

function periodCountKey(kind: BookingPeriodKind, count: number): MessageKey {
  const n = Math.max(1, Math.floor(count));
  const suffix = n === 1 ? 'one' : 'other';
  return `bookings.period.${kind}.${suffix}` as MessageKey;
}

/** Localized “2 years”, “1 day”, etc. */
export function formatBookingPeriodCountLabel(
  t: BookingTranslateFn,
  kind: BookingPeriodKind,
  count: number,
): string {
  const n = Math.max(1, Math.floor(count));
  return t(periodCountKey(kind, count), { count: n });
}

/** Localized “Start + 2 years”. */
export function formatBookingPeriodStartPlus(
  t: BookingTranslateFn,
  kind: BookingPeriodKind,
  count: number,
): string {
  return t('bookings.periodStartPlus', {
    period: formatBookingPeriodCountLabel(t, kind, count),
  });
}
